<template>
    <div>
<!--        <q-header />-->
        <div>
            <router-view />
        </div>
<!--        <q-footer />-->
    </div>
</template>

<script>
  import header from "./header";
  import footer from "./footer";

  export default {
    name: "Home",

    components: {
      'q-header': header,
      'q-footer': footer,
    },

    data() {
      return {};
    },
  };
</script>

<style scoped>

</style>
